
interface TableSkeletonProps {
  rows?: number;
  rowHeight?: number;
}

const TableSkeleton = ({ rows = 5, rowHeight = 50 }: TableSkeletonProps) => {
  return (
    <div className='w-full'>
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          style={{ height: rowHeight }}
          className='flex flex-col justify-center'
        >
          <div className='h-[30px] w-full animate-pulse rounded bg-gray-200' />
          <div className='mt-[9px] h-px w-full bg-gray-200' />
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;